import { render, staticRenderFns } from "./hospitalRanking.vue?vue&type=template&id=7001ad8c&scoped=true"
import script from "./hospitalRanking.vue?vue&type=script&lang=js"
export * from "./hospitalRanking.vue?vue&type=script&lang=js"
import style0 from "./hospitalRanking.vue?vue&type=style&index=0&id=7001ad8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001ad8c",
  null
  
)

export default component.exports